import React from 'react';

import { JRCStyledHref } from 'components/JRCHref/JRCHref';

import styled from 'styled-components';
import { JRCEllipsis } from 'components/JRCEllipsis/JRCEllipsis';

export const CSSRowLinkWrapper = styled(JRCStyledHref)`
    min-height: 24px;
    padding: 8px 0;
`;

export const JRCWidgetCheckListLink = ({ link }: { link: { href: string; target: string } }) => (
    <CSSRowLinkWrapper target={link.target} href={link.href}>
        <JRCEllipsis label={link.href} length={24}></JRCEllipsis>
    </CSSRowLinkWrapper>
);
